module.exports = __webpack_public_path__ + "img/maison4.1522d4c5.jpg";